import { type ScoreSettingsConfig } from '@soomo/lib/components/pageElements/GoReact/types';

const validateCompletionOptions = (scoreConfig: ScoreSettingsConfig) => {
	if (scoreConfig.completionOptions === undefined)
		throw new Error('Invalid config: Choose the completion option.');
};

const validateSelfReviewOptions = (scoreConfig: ScoreSettingsConfig) => {
	const selfReview = scoreConfig.completionOptions?.selfReview;
	if (
		selfReview.commentsNumber === 0 &&
		selfReview.markersNumber === 0 &&
		!selfReview.rubricSubmission
	)
		throw new Error('Invalid config: Choose at least one self-review option.');
};

const validateNonSelfReviewOptions = (scoreConfig: ScoreSettingsConfig) => {
	const nonSelfReview = scoreConfig.completionOptions?.nonSelfReview;
	if (nonSelfReview.reviewsNumber === 0)
		throw new Error('Invalid config: At least 1 review should be chosen.');
	if (
		nonSelfReview.commentsNumber === 0 &&
		nonSelfReview.markersNumber === 0 &&
		!nonSelfReview.rubricSubmission
	)
		throw new Error('Invalid config: Choose at least one non-self review option.');
};

export const validateScoreConfig = (scoreConfig: ScoreSettingsConfig) => {
	if (scoreConfig.scoreOptions === 'pointsForCompletion') {
		validateCompletionOptions(scoreConfig);
	}
	if (scoreConfig.completionOptions?.selfReview?.required) {
		validateSelfReviewOptions(scoreConfig);
	}
	if (scoreConfig.completionOptions?.nonSelfReview?.required) {
		validateNonSelfReviewOptions(scoreConfig);
	}
};
